import React, { useEffect } from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Schema from '../components/Schema';

const ContactUs = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, easing: 'ease-in-out', once: true });
  }, []);

  return (
    <div className="min-h-screen bg-[#f9f9f9] px-6 py-20 flex flex-col items-center">
    <Schema />
      <div className="w-full max-w-7xl">
      <h1
          className="text-6xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-7xl 2xl:text-8xl font-bold text-black text-center mb-10"
        >
    Contact Us
  </h1>

        <div className="grid md:grid-cols-2 gap-16">
          {/* Contact Details */}
          <div data-aos="fade-up" className="flex flex-col justify-center">
            <h2 className="text-xl font-semibold text-gray-800 mb-6">
              Our Office
            </h2>

            <div className="space-y-5 text-gray-600 text-base">
              <div className="flex items-start gap-4">
                <FaMapMarkerAlt className="text-blue-600 text-xl mt-1" />
                <p>44/1A Chapel Ln, Nugegoda, Sri Lanka</p>
              </div>
              <div className="flex items-start gap-4">
                <FaPhoneAlt className="text-blue-600 text-xl mt-1" />
                <p>077 712 9021, 011 419 9225</p>
              </div>
              <div className="flex items-start gap-4">
                <FaEnvelope className="text-blue-600 text-xl mt-1" />
                <a href="mailto:solarcareinternational@gmail.com" className="hover:underline">
                  solarcareinternational@gmail.com
                </a>
              </div>
              <div className="flex items-start gap-4">
                <FaEnvelope className="text-blue-600 text-xl mt-1" />
                <a href="mailto:info@solarcareinternational.com" className="hover:underline">
                  info@solarcareinternational.com
                </a>
              </div>
            </div>

            {/* Maps */}
            <div className="mt-10 space-y-6">
              <iframe
                title="Head Office Map"
                className="w-full h-64 rounded-xl border-none"
                loading="lazy"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31684.830307347377!2d79.9102467!3d6.8767376!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae2510c153426fb%3A0xf334d7811fc0f936!2sSolar%20care%20International%20(Pvt)%20Ltd%20(Head%20Office)!5e0!3m2!1sen!2slk!4v1693909000000!5m2!1sen!2slk"
              ></iframe>

              <iframe
                title="Nugegoda Map"
                className="w-full h-64 rounded-xl border-none"
                loading="lazy"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d126131.68097549986!2d79.97933795162727!3d6.927079046572121!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae25f365f62d021%3A0x42d95a7cb7d3a9a!2s44%2F1A%20Chapel%20Lane%2C%20Nugegoda%2C%20Sri%20Lanka!5e0!3m2!1sen!2sus!4v1693877364866!5m2!1sen!2sus"
              ></iframe>
            </div>
          </div>

          {/* Contact Form */}
          <div data-aos="fade-up" className="rounded-3xl p-10 shadow-none">
            <h2 className="text-xl font-semibold text-center text-gray-800 mb-8">
              Send Us a Message
            </h2>
            <form>
              {[
                { id: 'name', label: 'Name', type: 'text', placeholder: 'Full Name' },
                { id: 'email', label: 'Email', type: 'email', placeholder: 'Enter your email' },
              ].map(({ id, label, type, placeholder }) => (
                <div key={id} className="mb-5">
                  <label htmlFor={id} className="block text-sm font-medium mb-2 text-gray-700">
                    {label}
                  </label>
                  <input
                    id={id}
                    name={id}
                    type={type}
                    placeholder={placeholder}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm text-gray-800"
                  />
                </div>
              ))}

              <div className="mb-6">
                <label htmlFor="message" className="block text-sm font-medium mb-2 text-gray-700">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="4"
                  placeholder="Enter your message"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm text-gray-800"
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full bg-black text-white py-3 rounded-full text-sm font-medium hover:bg-gray-800 transition"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
